import { render, staticRenderFns } from "./annex.vue?vue&type=template&id=273639c7"
import script from "./annex.vue?vue&type=script&lang=js"
export * from "./annex.vue?vue&type=script&lang=js"
import style0 from "./annex.vue?vue&type=style&index=0&id=273639c7&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports